!function(global, factory) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = factory(require("preact")) : "function" == typeof define && define.amd ? define([ "preact" ], factory) : global.injectTapEventPlugin = factory(global.preact);
}(this, function(preact) {
    function proxy(attrs) {
        var map = {};
        for (var i in attrs) attrs.hasOwnProperty(i) && (map[i.toLowerCase()] = i);
        var start = attrs[map.ontouchstart], tap = attrs[map.ontouchtap], click = attrs[map.onclick];
        delete attrs[map.ontouchtap], attrs[map.onclick || "onClick"] = function(e) {
            if (click && click(e), !hasTouch) return tap(e);
        }, attrs[map.ontouchstart || "onTouchStart"] = function(e) {
            var down = coords(e);
            if (hasTouch = !0, addEventListener("touchend", function onEnd(e) {
                removeEventListener("touchend", onEnd);
                var up = coords(e), dist = Math.sqrt(Math.pow(up.x - down.x, 2) + Math.pow(up.y - down.y, 2));
                dist < OPTS.threshold && tap(e);
            }), start) return start(e);
        };
    }
    function coords(e) {
        var t = e.changedTouches && e.changedTouches[0] || e.touches && e.touches[0] || e;
        return {
            x: t.pageX,
            y: t.pageY,
            target: t.target
        };
    }
    var OPTS = {
        threshold: 10
    }, injected = void 0, hasTouch = void 0, index = function(opts) {
        for (var i in opts) opts.hasOwnProperty(i) && (OPTS[i] = opts[i]);
        if (!injected) {
            injected = !0;
            var oldHook = preact.options.vnode;
            preact.options.vnode = function(vnode) {
                var attrs = vnode.attributes;
                if (attrs) for (var _i in attrs) if (attrs.hasOwnProperty(_i) && "ontouchtap" === _i.toLowerCase()) {
                    proxy(attrs);
                    break;
                }
                oldHook && oldHook(vnode);
            };
        }
    };
    return index;
});
//# sourceMappingURL=preact-tap-event-plugin.js.map


//////////////////
// WEBPACK FOOTER
// ./~/preact-tap-event-plugin/dist/preact-tap-event-plugin.js
// module id = 112
// module chunks = 0